<div class="error-container">
    <div class="error-icon">
        <img height="16" width="16" src="assets/icons/Icon-Error.svg" alt="Error circle">
    </div>
    <div class="error-text">
        <span class="error-text-span" [innerHTML]="errorText"></span>
    </div>
</div>